import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from 'interfaces/paginate-duck';
import { Vehicle } from 'interfaces/vehicle';

const { Types, Creators } = createActions(
  {
    request: ['query'],
    success: ['data', 'pagination'],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'PAGINATE_REGIONAL_' }
);

export interface PaginateRegionalState extends IState {
  data: Vehicle[] | Record<string, any>[];
}

const INITIAL_STATE: PaginateRegionalState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateRegionalState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginateRegionalState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateRegionalState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateRegional = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateRegionalTypes = Types;
export const PaginateRegionalActions = Creators;
